import type { LocaleUrlBuilder } from '~/composables/types/localizable'
import {
  buildEventListPageLocaleUrl,
  buildMagazineLocaleUrl,
} from '~/composables/locale/urlBuilders'
import { isMagazineArticlePage, isEventListPage } from '~/utils/routeHelpers'

export const useLocaleUrlBuilder = (): LocaleUrlBuilder => {
  const route = useRoute()
  if (isMagazineArticlePage(route)) return buildMagazineLocaleUrl
  if (isEventListPage(route)) return buildEventListPageLocaleUrl
  return () => null
}
